import { BTIconHomeowners } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemShowOwnersProps {
    fileId: number;
    isVisibleToOwners: boolean;
    onClick: () => Promise<void>;
}

const MenuItemShowOwners = ({
    fileId,
    isVisibleToOwners,
    onClick,
    ...antProps
}: IMenuItemShowOwnersProps) => {
    const opacityPercent = isVisibleToOwners ? "40%" : "100%";
    const text = isVisibleToOwners ? "Hide from clients" : "Show clients";

    return (
        <BTMenu.Item
            {...antProps}
            key={`showOwners-menuitem-${fileId}`}
            testid={`showOwners-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconHomeowners style={{ opacity: opacityPercent }} /> {text}
        </BTMenu.Item>
    );
};

export default MenuItemShowOwners;
